export default __webpack_public_path__ + "static/media/person-with-eyes-closed.75a8df52.jpg";